import React from "react";
import { ReportModalData } from "./ReportModalData";
import { ReportValues } from "../shared/interfaces/ReportingPayload";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Button from "@mui/material/Button";
import { ReportingDescription } from "./ReportingDescription";

interface ReportingMeasurementModalProps {
  isOpen: boolean;
  onClose: () => void;
  reportValuesList: ReportValues[];
  reportModalData: ReportModalData[];
  matchingReportValuesList: ReportValues[];
  matchingReportModalData: ReportModalData[];
  onCreateReport: (description: string) => void;
}

export function ReportingMeasurementModal(props: ReportingMeasurementModalProps) {
  const {
    isOpen,
    onClose,
    reportValuesList,
    reportModalData,
    matchingReportValuesList,
    matchingReportModalData,
    onCreateReport,
  } = props;

  const [reportingDescription, setReportingDescription] = React.useState<string>("");

  const handleClose = () => {
    setReportingDescription("");
    onClose();
  };

  function renderDialogContent() {
    const hasMatchingReportValues = matchingReportValuesList.length > 0;
    const hasDefaultReportValues = reportValuesList.length > 0;
    if (hasMatchingReportValues && hasDefaultReportValues) {
      return (
        <div>
          <p>The following results will be included in the report with the values that you have selected.</p>
          {matchingReportModalData.map((rm) => {
            return <p key={rm.resultName}>{rm.resultName}</p>;
          })}
          <p>And the following results will be included in the report with the default values.</p>
          {reportModalData.map((rmd) => {
            return <p key={rmd.resultName}>{rmd.resultName}</p>;
          })}
          <ReportingDescription text={reportingDescription} onChange={(e) => setReportingDescription(e.target.value)} />
          <p>Click Create Report to continue.</p>
          <p>You will receive an email when the report is ready to view.</p>
        </div>
      );
    } else if (hasMatchingReportValues && !hasDefaultReportValues) {
      return (
        <div>
          <p>The following selected results will be included in the report.</p>
          {matchingReportModalData.map((rm) => {
            return <p key={rm.resultName}>{rm.resultName}</p>;
          })}
          <ReportingDescription text={reportingDescription} onChange={(e) => setReportingDescription(e.target.value)} />
          <p>Click Create Report to continue.</p>
          <p>You will receive an email when the report is ready to view.</p>
        </div>
      );
    } else if (!hasMatchingReportValues && hasDefaultReportValues) {
      return (
        <div>
          <p>The following results will be included in the report. Click Create Report to continue.</p>
          <p>You will receive an email when the report is ready to view: -</p>
          {props.reportModalData?.map((rmd) => {
            return <p key={rmd.resultName}>{rmd.resultName}</p>;
          })}
          <ReportingDescription text={reportingDescription} onChange={(e) => setReportingDescription(e.target.value)} />
        </div>
      );
    }
  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Create Reports</DialogTitle>
      <DialogContent>{renderDialogContent()}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        {(reportValuesList.length > 0 || matchingReportValuesList.length > 0) && (
          <Button onClick={() => onCreateReport(reportingDescription)}>Create Report</Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
